import axios from 'axios';
import {BASE_URL} from '../utils/Constant';

export function load(url, path) {
  return axios
    .get(BASE_URL + url, {params: {path}})
    .then((r) => r.data);
}
